module.exports = __webpack_public_path__ + "img/pt_pt.7d3d4eec.png";